import React, { useState } from "react";
import { Link } from "react-router-dom";

const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const DashboardComponent = ({ user }) => {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today.getDate());

  const handleDateClick = (day) => {
    setSelectedDate(day);
    console.log("Selected day is :", day);
  };

  const daysInMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  ).getDate();
  const firstDayIndex = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  ).getDay();

  const daysArray = Array.from({ length: firstDayIndex }, (_, i) => -1).concat(
    Array.from({ length: daysInMonth }, (_, i) => i + 1)
  );
  return (
    <div className="dashboard-content-container">
      <div className="dashboard-left-column">
        <div className="welcome-header">
          <h2>Hi {user.firstName}</h2>
          <p>Start looking for independent support workers near you.</p>
          <p>
            <Link to="/jobs">Jobs</Link>
          </p>
        </div>
        <div className="section">
          <div className="left-column-item">
            {/* <h2>Calandar</h2> */}
            <div className="calendar-widget">
              <h2>
                {today.toLocaleString("default", { month: "long" })}{" "}
                {today.getFullYear()}
              </h2>
              <div className="calendar">
                {daysOfWeek.map((day) => (
                  <div key={day} className="day-header">
                    {day}
                  </div>
                ))}
                {daysArray.map((day, index) => (
                  <div
                    key={index}
                    className={`calendar-day ${
                      day === selectedDate ? "selected-day" : ""
                    }`}
                    onClick={() => handleDateClick(day)}
                  >
                    {day !== -1 ? day : ""}
                  </div>
                ))}
              </div>
            </div>
            <p>
              Plan ahead and add your upcoming sessions so you and your client
              know who's coming when.
            </p>
          </div>
        </div>
        <div className="section">
          <h1>Get the support you need, when you need it.</h1>
          <div className="right-column-item">
            <h2>Book your support</h2>
            <p>
              We understand that caring for a senior loved one can be
              challenging. That's why we offer a variety of senior care support
              services to help you and your loved one live your best lives.
            </p>
          </div>
        </div>
      </div>
      <div className="dashboard-right-column">
        <div className="section">
          <h1>What's new?</h1>
          <div className="right-column-item">
            <h2>Tax and super calculators</h2>
            <p>
              Choose a date range and the percentage of your payments via
              WillCare you want to set aside to pay income tax or superannuation
              and we'll calculate the amount.
            </p>
            <button className="big-bold-button">Calculate Tax Now</button>
          </div>
        </div>
        <div className="section">
          <h1>You are safeguarded</h1>
          <div className="right-column-item">
            {/* <h2>What's new</h2> */}
            <p>
              Choose a date range and the percentage of your payments via
              WillCare you want to set aside to pay income tax or superannuation
              and we'll calculate the amount.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardComponent;
